import React from "react";

const STATIC_PAGE_PATH =
  process.env.CMC_PORTAL_STATIC_PAGE_ABSOLUTE_PATH || "/";
const AUTHENTICATED_PAGE_PATH =
  process.env.CMC_PORTAL_AUTHENTICATED_PAGE_ABSOLUTE_PATH || "/";
//api docs path has changed when accessed from static environment destinations
const DOCUMENTATION_PATH =
  STATIC_PAGE_PATH !== "/"
    ? STATIC_PAGE_PATH + "documentation/v1/"
    : "/api/v1/";

class FeaturesPage extends React.Component {
  render() {
    return (
      <section className="section-features container">
        <div className="px-3 py-3 pt-md-5 pb-md-5 mx-auto text-center">
          <h1 className="display-4">API Plan Feature Comparison</h1>
        </div>

        <div className="container px-3 py-3 pb-md-5 mx-auto">
          <div className="table-responsive">
            <table className="table table-bordered text-center">
              <thead>
                <tr>
                  <th scope="col">Feature</th>
                  <th scope="col">
                    <h2>Basic</h2>
                    <h3>Free</h3>
                    <p>No subscription required</p>
                  </th>
                  <th scope="col">
                    <h2>Hobbyist</h2>
                    <h3>
                      $29<small className="text-muted"> /mo</small>
                    </h3>
                    <p>
                      Billed annually <br />
                      or $35 /mo
                    </p>
                  </th>
                  <th scope="col">
                    <h2>Startup</h2>
                    <h3>
                      $79<small className="text-muted"> /mo</small>
                    </h3>
                    <p>
                      Billed annually <br />
                      or $95 /mo
                    </p>
                  </th>
                  <th scope="col">
                    <h2>Standard</h2>
                    <h3>
                      $299<small className="text-muted"> /mo</small>
                    </h3>
                    <p>
                      Billed annually <br />
                      or $375 /mo
                    </p>
                  </th>
                  <th scope="col">
                    <h2>Professional</h2>
                    <h3>
                      $699<small className="text-muted"> /mo</small>
                    </h3>
                    <p>
                      Billed annually <br />
                      or $875 /mo
                    </p>
                  </th>
                  <th scope="col">
                    <h2>Enterprise</h2>
                    <h3 className="custom-pricing-text">
                      Inquire for <br />
                      pricing
                    </h3>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Rest API</th>
                  <td>
                    9 latest market data endpoints & exchange asset reserve
                    endpoints
                  </td>
                  <td>
                    9 latest market data endpoints, exchange asset reserve &
                    limited historical
                  </td>
                  <td>
                    14 latest market data endpoints, exchange asset reserve &
                    limited historical
                  </td>
                  <td>
                    All latest, exchange asset reserve & historical market data
                    endpoints
                  </td>
                  <td>
                    All latest, historical market data, and exchange asset
                    reserve endpoints
                  </td>
                  <td>
                    All latest, historical market data, and exchange asset
                    reserve endpoints
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <a
                      rel="noopener noreferrer"
                      href="https://coinmarketcap.com/api/documentation/v1/#section/Authentication"
                      target="_blank"
                    >
                      Monthly API credits
                    </a>
                  </th>
                  <td>10,000</td>
                  <td>110,000</td>
                  <td>300,000</td>
                  <td>1,200,000</td>
                  <td>3,000,000</td>
                  <td>30,000,000</td>
                </tr>
                <tr>
                  <th scope="row">Support</th>
                  <td>Basic email</td>
                  <td>Basic email</td>
                  <td>Email</td>
                  <td>Email</td>
                  <td>Priority email</td>
                  <td>Priority email</td>
                </tr>
                <tr>
                  <th scope="row">License</th>
                  <td>Personal use</td>
                  <td>Personal use</td>
                  <td>
                    <b>Commercial use*</b>
                  </td>
                  <td>
                    <b>Commercial use*</b>
                  </td>
                  <td>
                    <b>Commercial use*</b>
                  </td>
                  <td>
                    <b>Custom license</b>
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <a
                      rel="noopener noreferrer"
                      href="https://coinmarketcap.com/api/documentation/v1/#section/Errors-and-Rate-Limits"
                      target="_blank"
                    >
                      Rate limit
                    </a>
                  </th>
                  <td>30 Requests per minute</td>
                  <td>30 Requests per minute</td>
                  <td>30 Requests per minute</td>
                  <td>60 Requests per minute</td>
                  <td>90 Requests per minute</td>
                  <td>120+ Requests per minute</td>
                </tr>
                <tr>
                  <th scope="row">Update frequency</th>
                  <td>**Every 1 minute</td>
                  <td>**Every 1 minute</td>
                  <td>**Every 1 minute</td>
                  <td>**Every 1 minute</td>
                  <td>**Every 1 minute</td>
                  <td>**Every 1 minute</td>
                </tr>
                <tr>
                  <th scope="row">Currency conversions</th>
                  <td>Limit 1 per call</td>
                  <td>Limit 8 per call</td>
                  <td>Limit 40 per call</td>
                  <td>Limit 40 per call</td>
                  <td>Limit 80 per call</td>
                  <td>Limit 120 per call</td>
                </tr>
                <tr>
                  <th scope="row">
                    Estimated cost per <br />
                    call credit
                  </th>
                  <td></td>
                  <td>~$0.00072</td>
                  <td>~$0.00065 (11% discount)</td>
                  <td>~$0.00059 (28% discount)</td>
                  <td>~$0.00023 (72% discount)</td>
                  <td>Custom (deepest discount)</td>
                </tr>
              </tbody>
            </table>

            <table className="table table-borderless text-center">
              <thead>
                <tr>
                  <th scope="row">&nbsp;</th>
                  <td>
                    <a
                      href={AUTHENTICATED_PAGE_PATH + "signup/?plan=0"}
                      className="btn btn-outline-secondary text-uppercase"
                    >
                      <span className="d-none d-md-block">
                        Get Free API Key
                      </span>
                      <span className="d-md-none">Go</span>
                    </a>
                  </td>
                  <td>
                    <a
                      href={AUTHENTICATED_PAGE_PATH + "signup/?plan=0.5"}
                      className="btn btn-outline-secondary text-uppercase"
                    >
                      <span className="d-none d-md-block">Get Started Now</span>
                      <span className="d-md-none">Go</span>
                    </a>
                  </td>
                  <td>
                    <a
                      href={AUTHENTICATED_PAGE_PATH + "signup/?plan=1"}
                      className="btn btn-outline-secondary text-uppercase"
                    >
                      <span className="d-none d-md-block">Get Started Now</span>
                      <span className="d-md-none">Go</span>
                    </a>
                  </td>
                  <td>
                    <a
                      href={AUTHENTICATED_PAGE_PATH + "signup/?plan=2"}
                      className="btn btn-outline-secondary text-uppercase"
                    >
                      <span className="d-none d-md-block">Get Started Now</span>
                      <span className="d-md-none">Go</span>
                    </a>
                  </td>
                  <td>
                    <a
                      href={AUTHENTICATED_PAGE_PATH + "signup/?plan=3"}
                      className="btn btn-outline-secondary text-uppercase"
                    >
                      <span className="d-none d-md-block">Get Started Now</span>
                      <span className="d-md-none">Go</span>
                    </a>
                  </td>
                  <td>
                    <a
                      href={AUTHENTICATED_PAGE_PATH + "contact/"}
                      className="btn btn-lg btn-block btn-primary"
                    >
                      Contact{" "}
                      <span className="d-none d-md-inline-block">us</span>
                    </a>
                  </td>
                </tr>
                <tr className="borderless">
                  <td colSpan="7">
                    <small className="text-muted">
                      * For 1 product only, up to 100k users. See{" "}
                      <a
                        rel="noopener noreferrer"
                        href={
                          AUTHENTICATED_PAGE_PATH + "user-agreement-commercial/"
                        }
                        target="_blank"
                      >
                        Terms of Use
                      </a>{" "}
                      for more details.
                    </small>
                  </td>
                </tr>
                <tr className="borderless">
                  <td colSpan="7">
                    <small className="text-muted">
                      ** Most endpoints update every 1 minute. See{" "}
                      <a
                        rel="noopener noreferrer"
                        href={DOCUMENTATION_PATH}
                        target="_blank"
                      >
                        API Documentation
                      </a>{" "}
                      for specific update frequency published for each endpoint.
                    </small>
                  </td>
                </tr>
              </thead>
            </table>

            <table className="table table-borderless text-center">
              <thead>
                <tr>
                  <th scope="col" colSpan="7">
                    Plan data access
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Cryptocurrency rankings</th>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Cryptocurrency pricing quotes</th>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Aggregate market data (Total market cap)</th>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Referential info</th>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Currency conversion calculator</th>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Exchange rankings</th>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Exchange volume quotes</th>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Exchange market pair data</th>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Exchange asset data</th>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                  <td>
                    <i className="fa fa-check"></i>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Historical data</th>
                  <td>&nbsp;</td>
                  <td>
                    <a
                      rel="noopener noreferrer"
                      href="https://coinmarketcap.com/api/documentation/v1/#operation/getV1ToolsPriceconversion"
                      target="_blank"
                    >
                      Currency Conversions
                    </a>
                    ,<br />
                    1-month (5-min interval),
                    <br />
                    12-months (daily interval)
                  </td>
                  <td>
                    <a
                      rel="noopener noreferrer"
                      href="https://coinmarketcap.com/api/documentation/v1/#operation/getV1ToolsPriceconversion"
                      target="_blank"
                    >
                      Currency Conversions
                    </a>{" "}
                    &{" "}
                    <a
                      rel="noopener noreferrer"
                      href="https://coinmarketcap.com/api/documentation/v1/#operation/getV1CryptocurrencyOhlcvHistorical"
                      target="_blank"
                    >
                      OHLCV
                    </a>
                    ,<br /> 1-month (5-min interval),
                    <br /> 24-months (daily interval)
                  </td>
                  <td>
                    All endpoints,
                    <br />
                    3-months (5-min interval),
                    <br /> 60-months (daily interval)
                  </td>
                  <td>
                    All endpoints,
                    <br />
                    12-months (5-min interval),
                    <br /> All-time (daily interval)
                  </td>
                  <td>
                    All endpoints,
                    <br />
                    all-time historical data
                  </td>
                </tr>
              </tbody>
            </table>

            <table className="table table-borderless text-center">
              <thead>
                <tr>
                  <th scope="col" colSpan="7">
                    Enterprise features
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">SLA</th>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>
                    <i className="fa fa-check blue"></i>
                    <br />
                    99.9% /mo
                  </td>
                </tr>
                <tr>
                  <th scope="row">Integration assistance</th>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>
                    <i className="fa fa-check blue"></i>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Dedicated infrastructure</th>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>
                    <i className="fa fa-check blue"></i>
                  </td>
                </tr>
              </tbody>
            </table>

            <table className="table table-bordered text-center second-price-table">
              <thead>
                <tr>
                  <th className="blue" scope="col">
                    Choose a plan
                  </th>
                  <th scope="col">
                    <h2>Basic</h2>
                    <h3>
                      $0<small className="text-muted"> /mo</small>
                    </h3>
                  </th>
                  <th scope="col">
                    <h2>Hobbyist</h2>
                    <h3>
                      $29<small className="text-muted"> /mo</small>
                    </h3>
                    <p>
                      Billed annually <br />
                      or $35 /mo
                    </p>
                  </th>
                  <th scope="col">
                    <h2>Startup</h2>
                    <h3>
                      $79<small className="text-muted"> /mo</small>
                    </h3>
                    <p>
                      Billed annually <br />
                      or $95 /mo
                    </p>
                  </th>
                  <th scope="col">
                    <h2>Standard</h2>
                    <h3>
                      $299<small className="text-muted"> /mo</small>
                    </h3>
                    <p>
                      Billed annually <br />
                      or $375 /mo
                    </p>
                  </th>
                  <th scope="col">
                    <h2>Professional</h2>
                    <h3>
                      $699<small className="text-muted"> /mo</small>
                    </h3>
                    <p>
                      Billed annually <br />
                      or $875 /mo
                    </p>
                  </th>
                  <th scope="col">
                    <h2>Enterprise</h2>
                    <h3 className="custom-pricing-text">
                      Inquire for <br />
                      pricing
                    </h3>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">&nbsp;</th>
                  <td>
                    <a
                      href={AUTHENTICATED_PAGE_PATH + "signup/?plan=0"}
                      className="btn btn-outline-secondary text-uppercase"
                    >
                      <span className="d-none d-md-block">
                        Get Free API Key
                      </span>
                      <span className="d-md-none">Go</span>
                    </a>
                  </td>
                  <td>
                    <a
                      href={AUTHENTICATED_PAGE_PATH + "signup/?plan=0.5"}
                      className="btn btn-outline-secondary text-uppercase"
                    >
                      <span className="d-none d-md-block">Get Started Now</span>
                      <span className="d-md-none">Go</span>
                    </a>
                  </td>
                  <td>
                    <a
                      href={AUTHENTICATED_PAGE_PATH + "signup/?plan=1"}
                      className="btn btn-outline-secondary text-uppercase"
                    >
                      <span className="d-none d-md-block">Get Started Now</span>
                      <span className="d-md-none">Go</span>
                    </a>
                  </td>
                  <td>
                    <a
                      href={AUTHENTICATED_PAGE_PATH + "signup/?plan=2"}
                      className="btn btn-outline-secondary text-uppercase"
                    >
                      <span className="d-none d-md-block">Get Started Now</span>
                      <span className="d-md-none">Go</span>
                    </a>
                  </td>
                  <td>
                    <a
                      href={AUTHENTICATED_PAGE_PATH + "signup/?plan=3"}
                      className="btn btn-outline-secondary text-uppercase"
                    >
                      <span className="d-none d-md-block">Get Started Now</span>
                      <span className="d-md-none">Go</span>
                    </a>
                  </td>
                  <td>
                    <a
                      href={AUTHENTICATED_PAGE_PATH + "contact/"}
                      className="btn btn-lg btn-block btn-primary"
                    >
                      Contact{" "}
                      <span className="d-none d-md-inline-block">us</span>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    );
  }
}

export default FeaturesPage;



// WEBPACK FOOTER //
// ./client/pages/main/features/index.jsx